import CustomSwitch from './CustomSwitch';

export default CustomSwitch;
